export default "__VITE_ASSET__B$VH0poy__"